module.exports = __webpack_public_path__ + "static/assets/4160ac4c39e1bb0f18553fb9473ba902.svg";